import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { DataService } from '@/app/services/shared/stage2.service';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CountryService } from '@/app/services/shared/country';
// import { AccordionComponent } from '../../project-stages/accordion/accordion.component';
import { NgToastService } from 'ng-angular-popup';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgxCurrencyDirective } from 'ngx-currency';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { ProjectsService } from '@/app/services/projects/projects.service';
import {
  PlanStep,
  ProgressService,
} from '@/app/services/shared/progress.service';
import { TabbedScrollerComponent } from '../../tabbed-scroller/tabbed-scroller.component';
import { currencyOptions } from '@/app/enums/currency-field-config';
import { DialogUtilityService } from '@/app/services/utility/dialog-utility.service';
import { ProgressBarComponent } from '../../progress-bar/progress-bar.component';
@Component({
  selector: 'app-cost-estimation',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgxPageScrollModule,
    NgxCurrencyDirective,
    ProgressBarComponent,
  ],
  templateUrl: './cost-estimation.component.html',
  styleUrls: ['./cost-estimation.component.css'],
})
export class CostEstimationComponent implements OnInit {
  items: any[] = [];
  index = 0;
  package_name: any = '';
  work_package = {
    cost_estimate: 0,
  };
  isLoadingNext: boolean = false;
  isLoadingSave: boolean = false;
  selectedSection = 'section1';
  stage2Progress: any;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private location: Location,
    private dataService: DataService,
    private toast: NgToastService,
    private countryServices: CountryService,
    private projectsService: ProjectsService,
    private getProjectIdService: GetProjectIdService,
    private progressService: ProgressService,
    private TabbedScrollerComponent: TabbedScrollerComponent,
    private dialogService: DialogUtilityService
  ) {}
  capbudget: any;
  country: any;
  @Output() returnBack: EventEmitter<any> = new EventEmitter<any>();

  currencyOptions = currencyOptions;

  ngOnInit() {
    // this.initilizeSavedPackages();
    // Subscribe to work_package_items changes
    this.dataService.getWorkPackageItems().subscribe((items: any) => {
      if (items?.children?.length > 0) {
        items.children.forEach((child: any) => {
          this.items = child;
        });
      } else {
        this.items = items;
      }
    });

    // Subscribe to package_name changes
    this.dataService.getPackageName().subscribe((name) => {
      this.package_name = name;
    });
    this.progressService.progress2$.subscribe((value) => {
      this.stage2Progress = value;
    });
    this.getProjectCountry();
  }

  private getProjectCountry() {
    // TODO: remove and add projectId from parent to child as these are wizards and dont have url
    const projectId = this.getProjectIdService.getProjectId();
    if (!projectId) {
      this.toast.danger('Project ID not found', 'DANGER', 4000);
      return;
    }

    this.projectsService.getProjectCountry(projectId).subscribe({
      next: (response: any) => {
        if (response?.meta?.success) {
          this.country = response.data;

          this.currencyOptions.prefix = this.country.symbol;

          return;
        }
        this.toast.danger('Country not found', 'DANGER');
      },
      error: (error: any) => {
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });
  }

  onCostEstimateChange(value: number): void {
    const maxValue = 100000000000; // 100 billion
    if (value > maxValue) {
      this.work_package.cost_estimate = maxValue;
    } else {
      this.work_package.cost_estimate = value;
    }
  }

  onChildCostEstimateChange(value: number, child: any): void {
    console.log('Triggered onChildCostEstimateChange', value, child);

    const maxValue = 100_000_000_000; // 100 billion
    const numericValue = Number(value); // Ensure it's a number

    console.log('value > maxValue', numericValue > maxValue);

    // Ensure Angular detects the change
    child = {
      ...child,
      cost_estimate: numericValue > maxValue ? maxValue : numericValue,
    };
  }

  numberToWords(num: any) {
    if (num === 0) return 'zero';

    const belowTwenty = [
      '',
      'one',
      'two',
      'three',
      'four',
      'five',
      'six',
      'seven',
      'eight',
      'nine',
      'ten',
      'eleven',
      'twelve',
      'thirteen',
      'fourteen',
      'fifteen',
      'sixteen',
      'seventeen',
      'eighteen',
      'nineteen',
    ];
    const tens = [
      '',
      '',
      'twenty',
      'thirty',
      'forty',
      'fifty',
      'sixty',
      'seventy',
      'eighty',
      'ninety',
    ];
    const thousands = ['', 'thousand', 'million', 'billion', 'trillion'];

    function helper(n) {
      if (n === 0) return '';
      else if (n < 20) return belowTwenty[n] + ' ';
      else if (n < 100) return tens[Math.floor(n / 10)] + ' ' + helper(n % 10);
      else
        return belowTwenty[Math.floor(n / 100)] + ' hundred ' + helper(n % 100);
    }

    let word = '';
    let index = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word = helper(num % 1000) + thousands[index] + ' ' + word;
      }
      num = Math?.floor(num / 1000);
      index++;
    }

    return word.trim();
  }

  initilizeSavedPackages() {
    this.projectsService.getResponsibilityMatrix().subscribe({
      next: (response: any) => {
        console.log('The fetch data is:', response);
      },
      error: (error: any) => {
        console.error('Login failed:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });

    let items: any = localStorage.getItem('work_package_items');
    items = JSON.parse(items);

    console.log('The local storage packages is:', items);

    if (items.children?.length > 0) {
      items.children.forEach((child: any) => {
        this.items = child;
      });
    } else {
      this.items = items;
    }
    const name: string = localStorage.getItem('package_name');

    this.package_name = name;
  }

  navigateWorkDistribution(action: string) {
    const dataToSubmit = new FormData();

    const projectId = this.getProjectIdService.getProjectId();
    if (!projectId) {
      this.toast.danger('Project ID not found', 'DANGER', 4000);
      return;
    }
    dataToSubmit.append('project_id', projectId);
    this.items.forEach((item: any, index) => {
      if (item.children.length > 0) {
        item.children.forEach((child: any) => {
          dataToSubmit.append(`work_packages[${index}][id]`, child.id);
          dataToSubmit.append(
            `work_packages[${index}][cost_estimate]`,
            child.cost_estimate
          );
          index++;
        });
      } else {
        dataToSubmit.append(`work_packages[${index}][id]`, item.id);
        dataToSubmit.append(
          `work_packages[${index}][cost_estimate]`,
          item.cost_estimate
        );
      }
    });
    if (action === 'next') {
      this.isLoadingNext = true;
    } else {
      this.isLoadingSave = true;
    }

    this.projectsService.saveCostEstimate(dataToSubmit).subscribe({
      next: () => {
        this.toast.success('Section saved successfully', 'SUCCESS', 4000);
        this.progressService.updateStepProgress(
          PlanStep.WorkPackagesCostEstimates,
          true
        );

        switch (action) {
          case 'next':
            this.isLoadingNext = false;
            this.TabbedScrollerComponent.nextStep();
            break;
          case 'save':
            this.isLoadingSave = false;
            break;
          default:
            this.isLoadingNext = false;
            this.isLoadingSave = false;
            break;
        }
      },
      error: (error: any) => {
        if (action === 'next') {
          this.isLoadingNext = false;
        } else {
          this.isLoadingSave = false;
        }

        console.error('Login failed:', error);
        this.toast.danger(error.error.message, 'DANGER', 4000);
      },
    });

    if (this.items.length > 0) {
      console.log('Cost Estimate Data: ', this.items);

      // this.toast.success('Section saved successfully', 'SUCCESS', 4000);
    } else {
      this.toast.danger(
        'Select any package from the dropdown first',
        'DANGER',
        4000
      );
    }
  }

  navigatetoPreviousPage() {
    this.location.back();
  }
  handleBack() {
    this.returnBack.emit();
    this.TabbedScrollerComponent.previousStep();
    if (this.items.length > 0) {
      this.navigateWorkDistribution('save');
    }
  }
  closeDialog() {
    this.dialogService.closeProjectPlanDialog();
    if (this.items.length > 0) {
      this.navigateWorkDistribution('save');
    }
  }
}
